import React from 'react';
import styled from 'styled-components';

interface SplitLayoutProps {
    leftContent: React.ReactNode;
    rightContent: React.ReactNode;
    reverse?: boolean;
}

const SplitContainer = styled.div<{ $reverse?: boolean }>`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
    width: 100%;
    height: 100%;
    
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: 1fr;
        gap: ${({ theme }) => theme.spacing.lg};
    }
`;

const LeftColumn = styled.div<{ $reverse?: boolean }>`
    order: ${({ $reverse }) => ($reverse ? 2 : 1)};
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    padding: ${({ theme }) => theme.spacing.xl};
    
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        order: 1;
        height: auto;
        min-height: 400px;
    }
`;

const RightColumn = styled.div<{ $reverse?: boolean }>`
    order: ${({ $reverse }) => ($reverse ? 1 : 2)};
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    padding: ${({ theme }) => theme.spacing.xl};
    
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        order: 2;
        height: auto;
        min-height: 400px;
    }
`;

export const SplitLayout: React.FC<SplitLayoutProps> = ({ 
    leftContent, 
    rightContent, 
    reverse 
}) => {
    return (
        <SplitContainer $reverse={reverse}>
            <LeftColumn $reverse={reverse}>{leftContent}</LeftColumn>
            <RightColumn $reverse={reverse}>{rightContent}</RightColumn>
        </SplitContainer>
    );
};
